import * as angular from "angular";
import {IController} from 'angular';
import * as _ from "lodash";
import {SiteFiltersType} from "../../types/site-filters.type";
import {PackingStatusType} from "../../../deliveries/types/packing-status.type";
import {SplitService} from "../../services/split-service.service";
import {FulfillmentSubTypeType} from "../../../fulfillment/types/fulfillment-sub-type.type";
import {CommissionDeltaType} from "../../../commissions/types/commission-delta.type";
import {CustomFieldModel} from "../../../site-preferences/models/custom-field.model";
import {FieldType} from "../../../site-preferences/types/field.type";
import {GroupModel} from "../../../groups/models/group.model";
import {RecurringType} from "../../types/recurring.type";
import {TagType} from "../../../tags/angular/types/tag.type";

export class bringozFiltersCtrl implements IController {

  includeFilters: SiteFiltersType[];
  excludeIdsMap: any;
  optionIdsMap: any;
  filters: any;
  queryMap: {};
  onChange: Function;
  onlyDataPane?: boolean;

  public siteFiltersType: typeof SiteFiltersType = SiteFiltersType;
  public packingStatusTypeMap: typeof PackingStatusType = PackingStatusType;
  public siteId: any;
  public filterOptions: any;
  public selectedFilter: any;
  public isMobile: boolean;
  public fulfillmentSubTypeType: typeof FulfillmentSubTypeType = FulfillmentSubTypeType;
  public commissionDeltaType: typeof CommissionDeltaType = CommissionDeltaType;
  public recurringType: typeof RecurringType = RecurringType;
  public selectedCustomField?: CustomFieldModel;
  public readonly fieldTypes: typeof FieldType = FieldType;
  public customPackageFields: CustomFieldModel[];
  public hasTeamsPermission: boolean;
  private groupBranchIds: string[];
  public tagType: typeof TagType = TagType;

  constructor(private splitService: SplitService, private commonsConstants, private $mdMedia, private $groups, private IAMPermissions) {
    this.customPackageFields = splitService.getCustomPackageFields();
  }

  $onInit() {
    this.siteId = this.splitService.getSiteId();
    this.hasTeamsPermission = this.IAMPermissions.hasPermission('teams.list');

    this._setFiltersOptions();
    this.isMobile = this.$mdMedia('xs');

    if (this.filters?.configuredFieldName) {
      this._setSelectedConfiguredField()
    }

    if (!this.isMobile && !this.onlyDataPane) {
      this.selectedFilter = this.filterOptions[0];
    }
  };

  $onChanges(changes) {
    if ((changes.includeFilters && !changes.includeFilters.isFirstChange())) {
      this._setFiltersOptions();
    }

    if (changes.filters) {
      this.initGroupFilterBranchIdOptions(this.filters.groups);
    }

    if (changes.selectedFilter && !changes.selectedFilter.isFirstChange()) {
      this.selectedFilter = changes.selectedFilter.currentValue;
    }
  };

  $doCheck() {
    this.isMobile = this.$mdMedia('xs');
  }

  onSelectFilter(filter) {
    this.selectedFilter = filter;
  }

  onToggleFilter(filter) {
    this.selectedFilter = this.selectedFilter ? undefined : filter;
  }

  onChangeFilter(filterName, updatedValue) {
    this.filters[filterName] = _.isNull(updatedValue) ? undefined : updatedValue;

    if (_.isEqual(filterName, 'groupIds')) {
      this.$groups().$asyncValues(updatedValue)
        .then((groups) => {
          let groupsBranchIds = [];
          groups.forEach((g: GroupModel) => {
            if (g.branchIds?.length) {
              groupsBranchIds = groupsBranchIds.concat(g.branchIds);
            }
          });
          this.filters.branchIds = _.uniq(this.filters.branchIds.concat(groupsBranchIds));
          this.excludeIdsMap.branchIds = groupsBranchIds;
        })
    }

    if (_.isEqual(filterName, 'branchIds') || _.isEqual(filterName, 'groupIds')) {
      this.filters.accountIds = [];
      this.filters.agentIds = [];
    }
  }

  onChangeFilterNoArea(isEnabled) {
    this.filters.noArea = isEnabled;
  }

  onChangeFilterNoPickupArea(isEnabled) {
    this.filters.noPickUpArea = isEnabled;
  }

  onChangeFilterNoDropoffArea(isEnabled) {
    this.filters.noDropOffArea = isEnabled;
  }

  onChangeFilterNoPickupAccount(isEnabled) {
    this.filters.noPickUpAccount = isEnabled;
  }

  onChangeFilterNoDropoffAccount(isEnabled) {
    this.filters.noDropOffAccount = isEnabled;
  }

  onToggleAccountPickup(accountPickup: boolean) {
    this.filters.accountPickup = accountPickup;
  }

  onToggleAccountDropoff(accountDropoff: boolean) {
    this.filters.accountDropoff = accountDropoff;
  }

  onChangeFilterNoPickupDepot(isEnabled) {
    this.filters.noPickUpDepot = isEnabled;
  }

  onChangeFilterNoDropoffDepot(isEnabled) {
    this.filters.noDropOffDepot = isEnabled;
  }

  onChangeFilterNoBranches(isEnabled) {
    this.filters.noBranches = isEnabled;
  }

  onChangeFilterGroups(groups) {
    this.filters.groups = groups;
    this.initGroupFilterBranchIdOptions(groups);
  }

  onCustomFieldSelect(customField: CustomFieldModel) {
    this.selectedCustomField = customField;
    this.filters.configuredFieldName = customField?.id;
    this.filters.configuredFieldValue = undefined;
    this.onChangeFilter(this.siteFiltersType.configuredFieldName, this.filters.configuredFieldName);
  }

  hasValue(value) {
    return !_.isUndefined(value) && !_.isNull(value);
  }

  isActiveFilter(filter) {
    if ((filter.id === 'configuredPackageField' && (!!this.filters.configuredFieldName || !!this.filters.configuredFieldValue))) return true;

    if (filter.type === 'LIST') {
      return (_.get(this.filters[filter.id], 'length')) ||
        (filter.id === 'serviceAreaIds' && !!this.filters.noArea && !!this.filters.noPickUpArea && !!this.filters.noDropOffArea) ||
        (filter.id === 'branchIds' && !!this.filters.noBranches);
    } else {
      return !_.isUndefined(this.filters[filter.id]);
    }
  }

  isIncludeFilter(id: string) {
    return _.includes(this.includeFilters, id);
  }

  private _setFiltersOptions() {
    let filterOptions = this.commonsConstants.siteFilters;

    // Set List By Include / Exclude
    if (_.get(this.includeFilters, 'length')) {
      filterOptions = _.filter(filterOptions, (sf) => {
        return _.includes(this.includeFilters, sf.id);
      })
    }

    // Set sub filters
    _.forEach(filterOptions, (f) => {
      if (!!f.subFilters) {
        _.forOwn(f.subFilters, (isEnabled, key) => {
          f.subFilters[key] = _.includes(this.includeFilters, key);
        })
      }
    })

    this.filterOptions = filterOptions;
  }

  private _setSelectedConfiguredField() {
    this.selectedCustomField = _.find(this.customPackageFields, (f: CustomFieldModel) => {
      return f.id === this.filters.configuredFieldName;
    })

    if (!!this.filters.configuredFieldValue && this.selectedCustomField.type === FieldType.Numeric) {
      this.filters.configuredFieldValue = _.toNumber(this.filters.configuredFieldValue)
    }
  }

  private initGroupFilterBranchIdOptions(groups) {
    this.groupBranchIds = [];
    groups?.forEach((g: GroupModel) => {
      if (g.branchIds?.length) {
        this.groupBranchIds = _.uniq(this.groupBranchIds.concat(g.branchIds));
      }
    });
  }

}

angular
  .module('bringoz.admin.commons')
  .component('bringozFilters', {
    bindings: {
      includeFilters: '<',
      excludeIdsMap: '<',
      optionIdsMap: '<?',
      filters: '<',
      queryMap: '<',
      onChange: '&',
      onlyDataPane: '<?',
      selectedFilter: '<?'
    },
    template: require('./bringoz-filters.html').default,
    controller: bringozFiltersCtrl
  });
